const colorRamp = [
    "rgba(247,147,30,1)",
    "rgba(247,147,30,.5)",
    "rgba(247,147,30,.3)",
    "rgba(247,147,30,.15)",
    "rgba(247,147,30,0)",
];

const layerProps = {
    county: {
        label: "County",
        zoomHint: "Zoom in to view county subdivisions.",
        minzoom: 0,
        maxzoom: 4,
        paint: {
            "fill-color": [
                "interpolate",
                ["linear"],
                ["get", "capacity_index_as_mean"],
                0.3,
                colorRamp[0],
                0.65,
                colorRamp[2],
                0.8,
                colorRamp[4],
            ],
            "fill-outline-color": [
                "interpolate",
                ["linear"],
                ["get", "capacity_index_as_mean"],
                0.0,
                colorRamp[0],
                0.01,
                colorRamp[2],
                0.9,
                colorRamp[4],
            ],
        },
    },
    tribe: {
        label: "Tribal Areas",
        zoomHint: "Zoom in to view county tribal areas.",
        minzoom: -1,
        maxzoom: -1,
        paint: {
          "fill-color": [
              "interpolate",
              ["linear"],
              ["get", "capacity_index_as_mean"],
              0.45,
              colorRamp[0],
              0.65, 
              colorRamp[2],
              0.8,
              colorRamp[4],
          ],

          "fill-outline-color": [
              "interpolate",
              ["linear"],
              ["get", "capacity_index_as_mean"],
              0.0,
              colorRamp[0],
              0.5,
              colorRamp[2],
              0.9,
              colorRamp[4],
          ],
      },
    },
    cousub: {
        label: "County Subdivision",
        zoomHint: "Zoom out to view counties or zoom in to view communities.",
        minzoom: 4,
        maxzoom: 9,
        paint: {
            "fill-color": [
                "interpolate",
                ["linear"],
                ["get", "capacity_index_as_mean"],
                0.3,
                colorRamp[0],
                0.5, 
                colorRamp[2],
                0.7,   
                colorRamp[4],
            ],

            "fill-outline-color": [
                "interpolate",
                ["linear"],
                ["get", "capacity_index_as_mean"],
                0.0,
                colorRamp[0],
                0.01,
                colorRamp[2],
                0.9,
                colorRamp[4],
            ],
        },
    },
    place: {
        label: "Community",
        zoomHint: "Zoom out to view county subdivisions.",
        minzoom: 9,
        maxzoom: 23,
        paint: {
            "fill-color": [
                "interpolate",
                ["linear"],
                ["get", "capacity_index_as_mean"],
                0.3,
                colorRamp[0],
                0.5,
                colorRamp[2],
                0.7,
                colorRamp[4],
            ],

            "fill-outline-color": [
                "interpolate",
                ["linear"],
                ["get", "capacity_index_as_mean"],
                0.0,
                colorRamp[0],
                0.5,
                colorRamp[2],
                0.9,
                colorRamp[4],
            ],
        },
    },
};
export { layerProps, colorRamp };
